import request from '@/utils/request'
const api = {
  getVideoList: 'video/getVideoList',
  searchVideoList: 'video/searchVideoList',
  getVideoPageList: 'video/getVideoPageList',
  getVideoTagsList: 'video/getVideoTagsList',
  getVideoItemList: 'video/getVideoItemList',
  getVideo: 'video/getVideo',
  getRandVideo: 'video/getRandVideo',
  addStar: 'video/addStar',
  addCollect: 'video/addCollect'
}
export default {
  getVideoList(parameter) {
    return request({
      url: api.getVideoList,
      method: 'POST',
      data: parameter
    })
  },
  searchVideoList(parameter) {
    return request({
      url: api.searchVideoList,
      method: 'POST',
      data: parameter
    })
  },
  getVideoPageList(parameter) {
    return request({
      url: api.getVideoPageList,
      method: 'POST',
      data: parameter
    })
  },
  getVideoTagsList(parameter) {
    return request({
      url: api.getVideoTagsList,
      method: 'POST',
      data: parameter
    })
  },
  getVideo(parameter) {
    return request({
      url: api.getVideo,
      method: 'POST',
      data: parameter
    })
  },
  getRandVideo(parameter) {
    return request({
      url: api.getRandVideo,
      method: 'POST',
      data: parameter
    })
  },
  getVideoItemList(parameter) {
    return request({
      url: api.getVideoItemList,
      method: 'POST',
      data: parameter
    })
  },
  addStar(parameter) {
    return request({
      url: api.addStar,
      method: 'POST',
      data: parameter
    })
  },
  addCollect(parameter) {
    return request({
      url: api.addCollect,
      method: 'POST',
      data: parameter
    })
  }
}
